import PropTypes from 'prop-types';
import React from 'react';
import TitleDateCopyright from './TitleDateCopyright';
import AuthorPriceViews from './AuthorPriceViews';
import DashboardTesTeachFooter from './DashboardTesTeachFooter';

var DashboardTesTeachCard = function DashboardTesTeachCard(_ref) {
  var authorUsername = _ref.authorUsername,
      date = _ref.date,
      lessonToken = _ref.lessonToken,
      lessonUrl = _ref.lessonUrl,
      title = _ref.title,
      views = _ref.views;
  return /*#__PURE__*/React.createElement("div", {
    className: "dashboard-card__container"
  }, /*#__PURE__*/React.createElement(TitleDateCopyright, {
    dateInfo: "Last Edited: ".concat(date),
    title: title,
    url: lessonUrl
  }), /*#__PURE__*/React.createElement(AuthorPriceViews, {
    authorLink: "/teaching-resources/shop/".concat(authorUsername),
    authorUsername: authorUsername,
    views: views
  }), /*#__PURE__*/React.createElement(DashboardTesTeachFooter, {
    lessonToken: lessonToken
  }));
};

DashboardTesTeachCard.displayName = "DashboardTesTeachCard";
DashboardTesTeachCard.propTypes = {
  authorUsername: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  lessonToken: PropTypes.string.isRequired,
  lessonUrl: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  views: PropTypes.number
};
export default DashboardTesTeachCard;